module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAMAAAAc9R5vAAAAP1BMVEUAAAD/AAD/VVX/XUbwZlDyZFT0ZFTyZVTzZFXzZFTyZFTyZVTxZFPyZVXxZFTyZFXxZFTyZVXzZVXzZVXyZVVZxftjAAAAFHRSTlMAAQMLI09wd3t/hY6Wn6PZ3e72+lGaiDwAAACCSURBVCjPpZJLDoMwDAUfgSRAgBCY+5+1i1ZVoFhC9K0sj/y39Fytj9G3P+4mFIASmpN/4aPlSAKQU8pAOOQvMDnJTVDqOh6ykySXwVcgQnpbCeIdYKYyi5vt2gOaK5HUzjCflzjufLWPFdiotN2JkCQNMFye0AQ99JegW9fuj5/RC/7LC0fSVCQqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/set_img/girl_icon.png
// module id = 253
// module chunks = 1